import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LmrComponent } from './lmr.component';
import { DealersComponent } from './pages/dealers/dealers.component';
import { BidComponent } from '../lmr/pages/bid/bid.component';
import { DialogNewDealerComponent } from './components/dialog-new-dealer/dialog-new-dealer.component';

import { LmrRoutingModule } from './lmr.routes';
import { DialogImportComponent } from './components/dialog-import/dialog-import.component';

import { DefectSolutionComponent } from './pages/defect-solution/defect-solution.component';
import { SharedModule } from '../../shared/shared.module';
import { HeadOfficeComponent } from './pages/head-office/head-office.component';
import { RepairTrackingComponent } from './pages/repair-tracking/repair-tracking.component';
import { RepairTrackingDetailsComponent } from './pages/repair-tracking-details/repair-tracking-details.component';

@NgModule({
  declarations: [
    LmrComponent,
    DealersComponent,
    BidComponent,
    DialogNewDealerComponent,
    DialogImportComponent,
    DefectSolutionComponent,
    HeadOfficeComponent,
    RepairTrackingComponent,
    RepairTrackingDetailsComponent,
  ],
  imports: [SharedModule, LmrRoutingModule, FormsModule],
})
export class LmrModule {}
